<template>

	<div class="transactions-list" @click="event => { event.stopPropagation() }">
		<v-row v-if="search && (transactions && transactions.length > 0 || allowSearchBack)">
			<v-col class="search-col">
				<v-text-field v-model="query" prepend-inner-icon="mdi-magnify" density="compact"
					label="Search transactions" variant="solo" :flat="true" hide-details clearable single-line
					@click:clear="$emit('cleared')"
					bg-color="#eeeeee"></v-text-field>
			</v-col>
		</v-row>
		<v-row v-if="query && transactions && transactions.length > 0">
			<v-col class="right">Total: {{ formatter.format(searchedTransactions.reduce((sum, group) => sum + group.reduce((groupSum, t) => groupSum + t.amount, 0), 0)) }}</v-col>
		</v-row>
		<div class="transactions">
			<div v-if="transactions && transactions.length > 0">
				<div v-for="(g, gIndex) in searchedTransactions" :key="gIndex">
					<v-row class="mt-2 mb-2" v-if="doShowDate">
						<v-col v-if="g[0].timestampString != today && g[0].timestampString != yesterday"
							class="date-col">{{ g[0].timestampString }}{{ dateCounts[g[0].timestampString] ? ` (${dateCounts[g[0].timestampString]})` : '' }}</v-col>
						<v-col v-if="g[0].timestampString == today" class="date-col">Today{{ dateCounts[g[0].timestampString] ? ` (${dateCounts[g[0].timestampString]})` : '' }}</v-col>
						<v-col v-if="g[0].timestampString == yesterday" class="date-col">Yesterday{{ dateCounts[g[0].timestampString] ? ` (${dateCounts[g[0].timestampString]})` : '' }}</v-col>
						<v-col class="dateTotal right" v-if="showDateTotal">{{ formatter.format(g.reduce((sum, t) => sum + t.amount, 0)) }}</v-col>
					</v-row>
					<v-row class="mb-1 transaction-row" v-for="(t, tIndex) in g" :key="t.id" @click="event => { event.stopPropagation(); navigateToTransaction(t); }">
						<v-divider v-if="dividingLines && (gIndex > 0 || tIndex > 0)" class="divider"></v-divider>
						<v-col class="v-col-2 icon-col" style="">
							<img v-if="t.effectiveClassification.iconPath"
								:src="require('@/assets/transactions/' + t.effectiveClassification.iconPath.toLowerCase().replace('.svg', '.png'))"
								class="icon">
							<img v-if="!t.effectiveClassification.iconPath" :src="require('@/assets/round3.png')"
								class="icon">
						</v-col>
						<v-col :class="t.availableVoucher ? 'v-col-5' : 'v-col-6'" class="details-col">
							{{ t.merchant ? t.merchant.name : t.merchantName }}<br />
							<span class="category">{{ (t.effectiveClassification.mgSubClassification ||
								t.effectiveClassification.mgClassification) }}</span><br/>
							<span class="tags" v-if="t.customerTags && t.customerTags.length > 0">
								<span v-for="tag in t.customerTags" :key="tag.id" class="tag">
									#{{ tag.tag }}
								</span>
							</span>
						</v-col>
						<v-col v-if="!context" :class="t.availableVoucher ? 'v-col-5' : 'v-col-4'" class="amount-col">
							<div v-if="t.amount < 0">
								{{ formatter.format(t.amount * -1) }}
							</div>
							<div v-else>
								<span class="moneyIn">+{{ formatter.format(t.amount) }}</span>
							</div>
							<div class="voucher-available" v-if="t.availableVoucher">{{ t.availableVoucher.effectiveDiscountPercentage }}% Voucher Available</div>
							<div v-if="t.excludeFromAnalysis" class="excluded-icon"><v-icon icon="mdi-poll" /> <v-icon icon="mdi-eye-off-outline" /></div>
						</v-col>
					</v-row>
					<v-divider class="mt-4" v-if="doShowDate && !dividingLines"></v-divider>
				</div>
			</div>
			<p v-if="!transactions || transactions.length == 0 && !hideEmptyDescription" class="centered small">{{ empDesc }}</p>
		</div>

		<div class="centered mt-7" v-if="search && query && allowSearchBack && query.length >= 3" @click="searchBack">Search Further Back</div>

	</div>

	<v-dialog class="transactionDialogue" transition="dialog-bottom-transition" fullscreen v-model="showModal" @click:outside="showModal = false; refreshSelectedTransaction();">
		<div class="mg-circle-image-button" :style="'top:' + (15 + (parseInt(this.$cookies.get('st') ?? 0))) + 'px'" @click="showModal = false; refreshSelectedTransaction();"><v-icon icon="mdi-close"/></div>
		<iframe :src="'/#/transaction/' + clickedTransaction.id + '?inModal=true'" style="width: 100%; height: 100%; border: none;"></iframe>
	</v-dialog>

</template>

<script>
export default {
	name: "TransactionsList",
	emits: ['refreshTransaction', 'cleared', 'searchBack'],
	props: {
		search: {
			type: Boolean,
			default: false
		},
		transactions: {
			type: Array,
			required: true
		},
		formatter: {
			type: Object,
			required: true
		},
		today: {
			type: String,
			required: true
		},
		yesterday: {
			type: String,
			required: true
		},
		showDate: {
			type: Boolean,
			default: true
		},
		showDateTotal: {
			type: Boolean,
			default: false
		},
		emptyDescription: {
			type: String,
			default: null
		},
		allowSearchBack: {
			type: Boolean,
			default: false
		},
		dividingLines: {
			type: Boolean,
			default: false
		},
		dateCounts: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			query: "",
			hide: [],
			context: false,
			doShowDate: true,
			empDesc: "There are no transactions to show. Offline accounts do not have transaction data, and newly added online accounts may take up to 5 minutes to show transactions.",
			clickedTransaction:null,
			showModal: false,
		}
	},
	computed: {
		searchedTransactions() {
			var ret = [];
			if (this.query) {
				var q = this.query.trim().toLowerCase();
				var friendlyAmount = this.query;
				if (friendlyAmount.includes('.') && friendlyAmount.endsWith('0')) {
					friendlyAmount = friendlyAmount.substring(0, friendlyAmount.length - 1);
					console.log(friendlyAmount);
				}
				this.transactions.forEach(g => {
					var ts = [];
					g.forEach(t => {
						if (
							t.merchantName.toLowerCase().includes(q)
							|| ((t.effectiveClassification.mgClassification && t.effectiveClassification.mgClassification.toLowerCase() + (t.excludeFromAnalysis ? ' (excluded)' : '') ).includes(q))
							|| (t.amount.toString().includes(friendlyAmount))
							|| (t.customerTags && t.customerTags.some(tag => tag.tag.toLowerCase().includes(q)))
						) {
								ts.push(t);
						}
					});
					if (ts.length > 0) {
						ret = [...ret, ts]
					}
				});
				return ret;
			} else {
				this.transactions.forEach(g => {
					var ts = [];
					g.forEach(t => {
						if (!this.hide.includes(t.merchantName.toLowerCase())) {
							ts.push(t);
						}
					});
					if (ts.length > 0) {
						ret = [...ret, ts]
					}
				});
				return ret;
			}
		},
	},
	methods: {
		onLoad() {
			if (this.showDate != null && !this.showDate) { this.doShowDate = false; }
			if (this.emptyDescription != null) { this.empDesc = this.emptyDescription; }
		},
		searchBack() {
			this.$emit('searchBack', this.query);
		},
		searchTransactions(query) {
			this.query = query;
		},
		navigateToTransaction(transaction) {
			this.clickedTransaction = transaction;
			this.showModal = true;
			//this.$router.push({ path: `/transaction/${transaction.id}` })
		},
		refreshSelectedTransaction() {
			if (this.clickedTransaction) {
				this.$emit('refreshTransaction', this.clickedTransaction.id);
			}
		}
	},
	mounted: function () { this.onLoad(); }
}
</script>

<style scoped>
.transactions-list {
	padding: 20px;
	z-index: 1000;
}

.transaction-row {
	align-items: flex-start !important;
}

.icon {
	width: 35px;
	background-color: #E7ECF7;
	border-radius: 90px;
}

.divider {
	margin-top: 1px;
	margin-bottom: 8px;
}

.amount-col {
	text-align: right;
	padding-top: 0px;
	padding-bottom: 0px;
	white-space: nowrap;
	align-self: flex-start;
}

.dateTotal{
	color: var(--grey-text)
}

.details-col {
	padding-top: 0px;
	padding-bottom: 0px;
	align-self: flex-start;
}

.icon-col {
	padding-top: 2px;
	padding-bottom: 0px;
	align-self: flex-start;
}

.context-col {
	text-align: right;
	padding-top: 0px;
	padding-bottom: 0px;
	vertical-align: center;

	img {
		opacity: 0.5;
	}

	transition: all .3s fade;
}

.context-button {
	width: 40px !important;
	padding: 0px !important;
	min-width: 40px !important;
	height: 40px !important;
	margin-left: -1px;
}

.context-close-button {
	width: 20px !important;
	padding: 0px !important;
	min-width: 20px !important;
	height: 40px !important;
	margin-left: -1px;
}

.date-col {
	font-size: 13px;
	padding-bottom: 10px;
}

.category {
	font-size: 11px;
	color: #555555;
	font-weight: lighter;
}

.voucher-available {
	font-size: 11px;
	margin-top: 4px;
}

.tags {
	font-size: 11px;
	color: var(--background-color-alt2);
	font-weight: lighter;
}

.moneyIn {
	background-color: #23af6433;
	color: #23AF64;
	padding: 3px;
	border-radius: 3px;
}

.excluded-icon {
	margin-top: 4px;
	color: var(--grey-text);
	font-size: 8px;
	text-decoration: strikethrough;
}

:deep(.v-overlay__content) {
	background-color: var(--background-color-alt) !important;
}

.mg-circle-image-button {
	background-color: #ffffff77;
	/* background-color: var(--text-color); */
	border-radius: 50% !important;
	height: 33px !important;
	width: 33px !important;
	padding-top: 7px !important;
	text-align: center;
	margin-top: -5px;
	font-size: 12px;
	z-index: 1000;
	position: absolute;
	top: 10px;
	right: 10px;
}
</style>